import { Star } from "lucide-react";

export function Stars({ value, onChange, size = 16 }: { value: number; onChange?: (value: number) => void; size?: number }) {
  const rounded = Math.round(value);
  if (!onChange) {
    return <span className="inline-flex items-center gap-0.5" aria-label={`${value.toFixed(1)} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((star) => <Star key={star} size={size} className={star <= rounded ? "fill-ribbon text-ribbon" : "text-line"} />)}
    </span>;
  }
  return <span className="inline-flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((star) => <button type="button" key={star} aria-label={`Rate ${star} out of 5 stars`} onClick={() => onChange(star)} className="grid size-9 place-items-center">
      <Star size={size} className={star <= value ? "fill-ribbon text-ribbon" : "text-cocoa/20"} />
    </button>)}
  </span>;
}
